<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-row justify="center">
            <v-dialog v-model="confirmDialog" persistent max-width="500" style="border-radius: 10px;">
                <v-card>
                    <v-card-title class="headline">
                        <span style="color: #d60000">{{ $t('system.alert') }}</span>
                    </v-card-title>
                    <v-card-text>
                        <span style="color: #d60000">{{ mensagemdialog }}</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="red accent-4"
                            class="white--text"
                            @click="confirmDialog = false"
                        >{{ messageDismissButton }}</v-btn>
                        <v-btn
                            v-if="showConfirmButton"
                            color="red accent-4"
                            class="white--text"
                            @click="deleteFromDatabase"
                        >{{ messageConfirmButton }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-container>
            <merus-data-table
                :headers="headersWithProperties"
                :items="labels"
                :loading="loading"
                :loading-text="$t('system.messages.loading')"
                sort-by="descricao_label_referente"
                dense
                class="elevation-7"
                locale="pt"
                style="border-radius: 10px"
                @update:displayedItems="displayedItemsForExport = $event"
            >
                <template v-slot:toolbar>
                    <CadastroToolbar
                        :title="$t('profiles.referents.title')"
                        :token="token"
                        :items="displayedItemsForExport !== null ? displayedItemsForExport : labels"
                        hide-search
                    >
                        <template v-slot:add>
                            <v-dialog v-model="dialog" max-width="600">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="primary"
                                        dark
                                        small
                                        class="mb-2"
                                        v-bind="attrs"
                                        fab
                                        v-on="{ ...on, click: (e) => { prepareNew(); if (on.click) on.click(e); } }"
                                    >
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline" style="color: #4a4a4a">{{ formTitle }}</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container>
                                            <v-form ref="form" v-model="formValidado">
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-text-field
                                                            v-model="editedItem.descricao_label_referente"
                                                            single-line
                                                            :label="$t('profiles.referents.placeholder')"
                                                            :rules="[(v) => !!v || $t('profiles.referents.required')]"
                                                            maxlength="50"
                                                            counter="50"
                                                        />
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-select
                                                            v-model="editedItem.tipos_notificacoes"
                                                            :items="tiposNotificacoes"
                                                            item-value="id_tipo_notificacao"
                                                            item-text="descricao_extenso"
                                                            :label="$t('profiles.referents.notificationTypes')"
                                                            :hint="$t('profiles.referents.notificationTypesHint')"
                                                            persistent-hint
                                                            :loading="loadingTipos"
                                                            multiple
                                                            chips
                                                            small-chips
                                                            deletable-chips
                                                            clearable
                                                        />
                                                    </v-col>
                                                </v-row>
                                            </v-form>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary darken-1" class="white--text" @click="close">{{ $t('button.cancel') }}</v-btn>
                                        <v-btn color="primary darken-1" class="white--text" @click="save">{{ $t('button.save') }}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </template>
                    </CadastroToolbar>
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" color="green" @click="editItem(item)">mdi-pencil</v-icon>
                    <v-icon small class="mr-2" color="red" @click="deleteItem(item)">mdi-delete</v-icon>
                </template>
            </merus-data-table>
        </v-container>
    </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import MerusDataTable from './Tables/MerusDataTable.vue';
import translateDbField from "@/utils/translateDbField";

export default {
    name: 'PerfisReferentes',
    components: {
        CadastroToolbar,
        MerusDataTable,
    },
    data: () => ({
        confirmDialog: false,
        showConfirmButton: false,
        mensagemdialog: "",
        messageDismissButton: "",
        messageConfirmButton: "",
        token: null,
        loading: false,
        loadingTipos: false,
        labels: [],
        tiposNotificacoes: [],
        displayedItemsForExport: null,
        dialog: false,
        formValidado: false,
        editedIndex: -1,
        editedItem: {
            id_label_referente: null,
            descricao_label_referente: null,
            translation_key: null,
            tipos_notificacoes: [],
        },
        deletedItem: {
            id_label_referente: null,
            descricao_label_referente: null,
            translation_key: null,
            tipos_notificacoes: [],
        },
        defaultItem: {
            id_label_referente: null,
            descricao_label_referente: null,
            translation_key: null,
            tipos_notificacoes: [],
        },
    }),
    created() {
        this.token = sessionStorage.getItem("api");
        this.initialize();
        this.populaTiposNotificacoes();
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1
                ? this.$t('profiles.referents.create')
                : this.$t('profiles.referents.edit');
        },
        headers() {
            return [
                { text: this.$t('profiles.referents.headers.id'), value: "id_label_referente", align: " d-none" },
                { text: this.$t('profiles.referents.headers.description'), value: "descricao_label_referente" },
                { text: this.$t('profiles.referents.headers.notificationTypes'), value: "tipos_notificacoes_extenso", sortable: false },
                { text: this.$t('profiles.referents.headers.actions'), value: "actions", sortable: false, align: "end" },
            ];
        },
        headersWithProperties() {
            return this.headers.map((header) => ({
                ...header,
                filtrable: true,
                sortable: true,
            }));
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            this.populaTiposNotificacoes();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
    },
    methods: {
        prepareNew() {
            this.editedIndex = -1;
            this.editedItem = Object.assign({}, this.defaultItem, { tipos_notificacoes: [] });
        },
        // Rotulo dos tipos assinados, ja traduzido. '—' distingue "nenhum" de vazio na exportacao.
        descreveTipos(detalhe) {
            const nomes = (detalhe || []).map((t) =>
                translateDbField(t.translation_key, t.descricao_tipo_notificacao)
            );
            return nomes.length > 0 ? nomes.join(', ') : '—';
        },
        populaTiposNotificacoes() {
            this.loadingTipos = true;
            apiController.request(apiController.endpoints.getallTiposnotificacoes, {
                data: {},
                onSuccess: (response) => {
                    const rows = Array.isArray(response.data) ? response.data : [];
                    this.tiposNotificacoes = rows.map((row) => ({
                        ...row,
                        descricao_extenso: translateDbField(
                            row.translation_key,
                            row.descricao_tipo_notificacao
                        ),
                    }));
                },
                onError: () => {
                    this.tiposNotificacoes = [];
                },
            })
                .catch(() => {})
                .finally(() => {
                    this.loadingTipos = false;
                });
        },
        initialize() {
            this.loading = true;
            apiController.request(apiController.endpoints.getallLabelreferentes, {
                data: {},
                onSuccess: (response) => {
                    const rows = Array.isArray(response.data) ? response.data : [];
                    this.labels = rows.map((row) => ({
                        ...row,
                        tipos_notificacoes: Array.isArray(row.tipos_notificacoes)
                            ? row.tipos_notificacoes
                            : [],
                        tipos_notificacoes_extenso: this.descreveTipos(row.tipos_notificacoes_detalhe),
                        descricao_label_referente: translateDbField(
                            row.translation_key,
                            row.descricao_label_referente
                        ),
                    }));
                    this.loading = false;
                },
                onError: () => {
                    this.labels = [];
                    this.loading = false;
                },
            });
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.deletedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            });
        },
        save() {
            if (!this.$refs.form || !this.$refs.form.validate()) {
                return;
            }
            // O `clearable` do seletor zera para null, e o back trata null como "não mexer".
            // Limpar todos os tipos precisa chegar como array vazio para de fato limpar.
            const payload = {
                ...this.editedItem,
                tipos_notificacoes: Array.isArray(this.editedItem.tipos_notificacoes)
                    ? this.editedItem.tipos_notificacoes
                    : [],
            };
            if (this.editedIndex === -1) {
                apiController.request(apiController.endpoints.insertLabelreferente, {
                    data: payload,
                    onSuccess: (response) => {
                        this.updateTable(response.data);
                    },
                });
            } else {
                apiController.request(apiController.endpoints.updateLabelreferente, {
                    data: payload,
                    onSuccess: (response) => {
                        this.updateTable(response.data);
                    },
                });
            }
        },
        deleteFromDatabase() {
            this.confirmDialog = false;
            apiController.request(apiController.endpoints.deleteLabelreferente, {
                data: this.deletedItem,
                onSuccess: (response) => {
                    this.updateTable(response.data);
                },
            });
        },
        editItem(item) {
            this.editedIndex = this.labels.indexOf(item);
            this.editedItem = Object.assign({}, item, {
                tipos_notificacoes: [...(item.tipos_notificacoes || [])],
            });
            this.dialog = true;
        },
        deleteItem(item) {
            this.deletedItem = Object.assign({}, item);
            this.mensagemdialog =
                this.$t('profiles.referents.confirmation') + " " + item.descricao_label_referente + " ?";
            this.showConfirmButton = true;
            this.messageDismissButton = this.$t('button.dismiss');
            this.messageConfirmButton = this.$t('button.confirm');
            this.confirmDialog = true;
        },
        updateTable(data) {
            EventBus.$emit('show-alert', {
                mensagem: data.mensagem,
                tipo: data.erro ? 'error' : 'success',
            });
            this.initialize();
            this.close();
        },
    },
};
</script>
